import { EmployeeAbsenceModelType } from '@teinor/erp/types/company/userInner/employee/employeeAbsence'
import { useCallback, useEffect, useState } from 'react'
import LoadingSpinner from '../../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModalLittle } from '../../../../../../../../../../baseComponents/Modal'
import { ModalCreateEditStructureLayout } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import CustomRenderSchedules from '../../../../../../../../../../specificComponents/WCal/schedule/CustomRenderSchedules'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { displayDate } from '../../../../../../../../../../utils/globals/date'
import { valueOrDefaultValue } from '../../../../../../../../../../utils/globals/valueOrDefaultValue'
import useStatusRequestTypes from '../../../../../../../../../../utils/hooks/useStatusRequestTypes'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalUserNotificationsAbsencesProps extends ModalUserNotificationsAbsencesLogicProps {
}

const ModalUserNotificationsAbsences: React.FC<ModalUserNotificationsAbsencesProps> = ({ userPermissions, setOpened, allRowData, onSubmit }) => {
    const { t } = useTwinTranslation()
    const status = useStatusRequestTypes()
    const { data } = useModalUserNotificationsAbsencesLogic({ allRowData, setOpened, onSubmit })
    if (!data) {
        return (
            <ModalLittle opened={true} setOpened={setOpened} onClickOut={false} className={'flex flex-col'}>
                <LoadingSpinner />
            </ModalLittle>
        )
    }
    const fields: FormRender<EmployeeAbsenceModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'EmployeeId',
                    component: 'TextField',
                    value: data?.Employee?.fullname_short,
                    label: t('employee', 'Empleado')
                },
                {
                    name: 'dateStart',
                    component: 'TextField',
                    label: t('dateStart', 'Fecha inicio'),
                    value: displayDate(new Date(data?.dateStart || ''))
                },
                {
                    name: 'dateEnd',
                    component: 'TextField',
                    label: t('dateEnd', 'Fecha fin'),
                    value: displayDate(new Date(data?.dateEnd || '')),
                },
                {
                    name: 'description',
                    component: 'TextField',
                    label: t('description', 'Descripción'),
                    value: data?.description
                },
                {
                    name: 'EmployeeAbsenceTypeId',
                    component: 'TextField',
                    label: t('type', 'Tipo'),
                    value: data?.EmployeeAbsenceType?.name
                },
                {
                    name: 'schedule',
                    component: 'Custom',
                    render: ()=> <CustomRenderSchedules schedule={data?.schedule} />
                },
                {
                    name: 'proof_file_url',
                    component: 'FilesInput',
                    label: t('absenceProof', 'Justificante ausencia'),
                    defaultValue: data?.proof_file_url,
                    readOnly: true
                },
                {
                    name: 'approved',
                    component: 'TextField',
                    label: t('status', 'Estado'),
                    value: status[parseInt(String(data?.approved))]?.name
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: data?.id
                },
            ]
        },
    ]
    const userPermission = userPermissions ?? { n: 1, permission: 'read' }
    const parsedFields = valueOrDefaultValue(fields, userPermission, allRowData)
    return (
        <ModalLittle opened={true} setOpened={setOpened} onClickOut={false} className={'flex flex-col'}>
            <ModalCreateEditStructureLayout loading={false} translations={{
                title: t('notificationInfo', 'Información de la notificación'),
                button: ''
            }} haveButtonPermissions={false} >
                <div className='overflow-auto flex flex-auto flex-col'>
                    {fields.length ?
                        <FormRenderer sections={parsedFields} className='grid_mincontent' />
                    : null}
                </div>
            </ModalCreateEditStructureLayout>
        </ModalLittle>
    )
}

interface ModalUserNotificationsAbsencesLogicProps extends ModalEditComponentProps {
}

const useModalUserNotificationsAbsencesLogic = ({ allRowData }: ModalUserNotificationsAbsencesLogicProps) => {
    const [data, setData] = useState<EmployeeAbsenceModelType | null>(null)

    const getAbsenceData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/employee/employeeAbsence/getEmployeeAbsenceInstance', { id: allRowData?.SubId })
        if (result) {
            setData(result)
        }
    }, [setData, allRowData?.SubId])

    useEffect(() => {
        getAbsenceData()
    }, [getAbsenceData])
    return { data }
}




export default ModalUserNotificationsAbsences